import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18">
            {props.breadcrumbItem}
          </h4>

          <div className="page-title-right">
            <ol className="breadcrumb m-0">

              {/* FIRST breadcrumb – clickable */}
              <BreadcrumbItem>
                <Link to={props.backLink || "#"}>
                  {props.title}
                </Link>
              </BreadcrumbItem>

              {/* SECOND breadcrumb – active, NOT a link */}
              <BreadcrumbItem active>
                {props.breadcrumbItem}
              </BreadcrumbItem>

            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
  backLink: PropTypes.string
}

export default Breadcrumb